export default __webpack_public_path__ + "static/media/jollen.ca0e570f.svg";